import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import {from, Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { publicIpv4 } from 'public-ip';

@Injectable({
  providedIn: 'root',
})
export class BackendService {
  private baseURL: string = environment.node_api_base_url;
  private csrfTokenURL: string = environment.csrf_token_url;
  headers: any = {};
  private userIp;

  constructor(public http: HttpClient) {}

  Get<T>(key, params?, options = {}): Observable<T> {
    const url = this.resolveUrl(key);
    options = { ...options, params: params || {} };
    return this.http.get<T>(url, options);
  }

  Put(key, params, options = {}): Observable<any> {
    const url = this.resolveUrl(key);
    return this.http.put(url, params || {}, options);
  }

  Post(key, params, options = {}): Observable<any> {
    const url = this.resolveUrl(key);
    return this.http.post(url, params || {}, options);
  }

  GetAPICall(key, token = '', params?): Observable<any> {
    const url = this.resolveUrl(key);
    let httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    });
    let options = {
      headers: httpHeaders,
    };
    if (params) {
      options['params'] = params;
    }
    return this.http.get<any>(url, options);
  }
  PostAPICallGoldFinch(url, params, token?, payload?): Observable<any> {
    let httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    });
    let options = {
      headers: httpHeaders,
    };
    return this.http.post(url, params || {}, options);
  }

  PostAPICall(key, params, token = ''): Observable<any> {
    const url = this.resolveUrl(key);
    let httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    });
    let options = {
      headers: httpHeaders,
    };
    return this.http.post(url, params || {}, options);
  }

  PostInstanceAPICall(key, params, token = ''): Observable<any> {
    const url = this.resolveUrl(key);
    let httpHeaders = new HttpHeaders({
      enctype: 'multipart/form-data',
      Authorization: 'Bearer ' + token,
    });
    let options = {
      headers: httpHeaders,
    };
    return this.http.post(url, params || {}, options);
  }

  PostExternalAPICall(url, params, token?): Observable<any> {
    let httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    let options = {
      headers: httpHeaders,
    };
    return this.http.post(url, params || {}, options);
  }

  postApiTermsCall(key, payload, token) {
    const url = this.resolveUrl(key);
    let httpHeaders = new HttpHeaders();
    if (token) {
      httpHeaders = new HttpHeaders({
        Authorization: 'Bearer ' + token,
      });
    }
    let options = {
      headers: httpHeaders,
    };
    return this.http.post(url, payload, options);
  }

  PostExternalTokenAPICall(url, params, token?): Observable<any> {
    let httpHeaders = new HttpHeaders();
    let options = {
      headers: httpHeaders,
    };
    return this.http.post(url, params || {}, options);
  }

  PostMilestoneAPICall(url, params, token?): Observable<any> {
    // let httpHeaders = new HttpHeaders({
    //   'Content-Type': 'application/json',
     
    // });
    // let options = {
    //   responseType: 'text',
    //   headers: httpHeaders,
    // };
    const headers = {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    };
    return this.http.post(url, params || {}, { headers, responseType: 'text', observe: 'response' });
  }

  PostExternalTokenUpdatedAPICall(url, params, token?): Observable<any> {
    let httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    });
    let options = {
      headers: httpHeaders,
    };
    return this.http.post(url, params || {}, options);
  }
  // PostExternalTokenUpdatedAPICalls(url, params, token, x_api_key): Observable<any> {
  //   let httpHeaders = new HttpHeaders({
  //     'Content-Type': 'application/json',
  //     Authorization: 'Bearer ' + token,
  //     'X-API-Key':x_api_key
  //   });
  //   let options = {
  //     headers: httpHeaders,
  //   };
  //   return this.http.post(url, params || {}, options);
  // }
  GetTempletes(url,x_api_key): Observable<any> {
    let httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + "",
      'X-API-Key': x_api_key
    });
    let options = {
      headers: httpHeaders,
    };
    return this.http.get(url,options);
  }

  TestAiopsAPICall(url, params, token): Observable<any> {
    const startTime = performance.now();
  
    let httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + null,
      'X-API-Key': token
    });
  
    let options = { headers: httpHeaders, observe: 'response' as 'body' };
  
    return this.http.post(url, params || {}, options)
  }
  

  PostExternalTokenGoldfinchAPICall(url, params, token?): Observable<any> {
    let httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    });
    let options = {
      headers: httpHeaders
    };
    return this.http.post(url, params || {}, options);
  }
  PutExternalTokenGoldfinchAPICall(url, params, token?): Observable<any> {
    let httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    });
    let options = {
      headers: httpHeaders
    };
    return this.http.put(url, params || {}, options);
  }

  PostParamsAPICall(key,params,token): Observable<any> {
    const url = this.resolveUrl(key);
    let httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    });
    let options = {
      headers: httpHeaders
    };
    return this.http.post(`${url}/${params}`, {} , options);
  }

  getExternalTokenGoldfinchAPICall(url, token?): Observable<any> {
    let httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    });
    let options = {
      headers: httpHeaders
    };
    return this.http.get(url, options);
  }

  PutAPICall(key, params, token = ''): Observable<any> {
    const url = this.resolveUrl(key);
    let httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    });
    let options = {
      headers: httpHeaders,
    };
    return this.http.put(url, params || {}, options);
  }

  PutInstanceAPICall(key, params, token = ''): Observable<any> {
    const url = this.resolveUrl(key);
    let httpHeaders = new HttpHeaders({
      enctype: 'multipart/form-data',
      Authorization: 'Bearer ' + token,
    });
    let options = {
      headers: httpHeaders,
    };
    return this.http.put(url, params || {}, options);
  }

  DeleteAPICall(endpoint, token = '',params?): Observable<any> {
    const url = this.baseURL + `${endpoint}`;
    let httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    });
    let options = {
      headers: httpHeaders,
    };
    if(params){
      options['params']=params;
    }
    return this.http.delete(url, options);
  }

  fileUpload(key, method, params, token = '') {
    const url = this.resolveUrl(key);
    let httpHeaders = new HttpHeaders();
    if (token) {
      httpHeaders = new HttpHeaders({
        Authorization: 'Bearer ' + token,
      });
    }
    let options = {
      headers: httpHeaders,
    };
    if (method == 'post') {
      return this.http.post(url, params || {}, options);
    } else if (method == 'put') {
      return this.http.put(url, params || {}, options);
    }
  }

  // getUserIp<T>(): Observable<T> {
  //   let url = 'https://api.ipif.or/?format=json';
  //   return this.http.get<T>(url).pipe(
  //     map((res) => {
  //       return res;
  //     })
  //   );
  // }

  getUserIp<T>(): Observable<T> {
    return new Observable<T>((observer) => {
      publicIpv4().then((ip) => {
        let e={'ip':ip}
        observer.next(e as T);
        observer.complete();
      }).catch((error) => {
        observer.error(error);
      });
    });
  }

  resolveUrl(key) {
    let url = '';
    this.urlHub().forEach((element) => {
      if (element.api.filter((f) => f === key).length) {
        url = `${element.baseUrl}/${element.route}/${key}`;
      }
    });
    return url;
  }

  // Subscribe(params): Observable<any> {
  //   const url = this.baseURL + "/api/users/subscribe";
  //   let httpHeaders = new HttpHeaders({
  //     'Content-Type' : 'application/json',
  //     'Cache-Control': 'no-cache'
  //   });
  //   let options = {
  //     headers: httpHeaders
  //   };
  //   return this.http.post(url, params || {}, options);
  // }

  urlHub() {
    return [
      {
        api: [
          'register',
          'getCode',
          'sendCode',
          'securityQuestions',
          'setPassword',
          'login',
          'subscribe',
          'forgotPassword',
          'resetPassword',
          // 'changePassword',
          'validateLoggedInSession',
          'refreshToken',
          'createNewUserApi',
          'getAllUsers',
          'getApiUser',
          'editApiUser',
          'updateApiuser',
          'getAllUserGroups',
          'addUserGroups',
          'editUserGroups',
          'updateUserGroups',
          'updateProfileImage',
          'getUserProfileImage',
          'saveProfileImage',
          'changeUserPassword',
          'setPopUpFlag',
          'getAllCatAdminUsers',
          'createCatAdminUser',
          'getCatAdminUser',
          'updateCatAdminUser',
          'setActivity',
          'getActivity',
          'view',
          'getViews',
          'getViewById',
          'updateView',
          'getApiTerms',
          'blockUser',
          'getJDBCenv',
          'createJDBCenv',
          'getJDBCenvById',
          'updateJDBCenv',
          'getJDBCenvDetails',
          'deleteJDBCenv',
          'getAllUsersActivity',
          'getOrgUsersActivity',
          // 'getActivity',
          'getConfig',
          'getAllConfig',
          'updateConfig',
          'generateQR',
          'storeQR',
          'disableQR',
          'createGroup',
          'getGroupList',
          'getGroupById',
          'updateGroup',
          'getAnalyticPerms',
          'getGroupFilterById',
          'getGroupFilterByGroupId',
          'createGroupFilter',
          'updateGroupFilter',
          'getDatalakeIndex',
          'logout',
          'csrf_token',
          'deleteGroup',
          'get_client_token',
          'saveClientDetails',
          'updateClientDetails',
          'viewClientDetails',
          'deleteClientDetails',
          'listActiveClients',
          'createClientId',
          'refreshClientSecret'
        ],
        baseUrl: this.baseURL,
        route: 'api/users',
      },
      {
        api: [
          'getCategory',
          'getBrand',
          'getPrice',
          'getType',
          'getMethod',
          'getAuth',
          'getApiCatalogueSource',
          'getMarketplaceApiCatalogueSource',
          'updateApiCatalogueSource',
          'createApiCatalogue',
          'getApiCatalogue',
          'getAllCategories',
          'getAllMarketplaceCategories',
          'createCategory',
          'editCategory',
          'updateCategory',
          'getAllBrands',
          'createNewBrand',
          'editBrand',
          'updateBrand',
          'deleteBrand',
          'getBrandsByCatId',
          'getWorkflowStatus',
          'getCatalogByCategoryId',
          'getBrandsByCategoryIds',
          'apiCatalogCall',
          'getCatalogueSourceTarget',
          'getBusinessObject',
          'updateCatalogImage',
          'saveCatalogImage',
          'marketplace',
          'getCatalogueFilters',
          'cart',
          'cartDetails',
          'deleteCart',
          'getMarketplaceCatalogueFilters',
          'getAllProducts',
          'createNewProduct',
          'editProduct',
          'getProductDetails',
          'updateProduct',
          'deleteProduct',
          'getProductsByBrandId',
          'getSource',
          'getTarget',
          'copyApiCatalog',
          'getHeaderKeys',
          'getHeaderValues',
          'importApiCatalogue',
          'exportApiCatalogue',
        ],
        baseUrl: this.baseURL,
        route: 'api/catalogue',
      },
      {
        api: [
          'getApiOrganization',
          'editApiOrganization',
          'updateApiOrganization',
          'delApiOrganization',
          'updateCompanyLogo',
          'getLogoImage',
          'getApiLogoImage',
          'saveCompanyLogo',
          'getProfileInfo',
          'updateProfileInfo',
          'updateVisualizationAccess',
          'updateGoldfinchAccess',
          'getLogoImage'
        ],
        baseUrl: this.baseURL,
        route: 'api/organization',
      },
      {
        api: [
          'getAllIntBridge',
          'getAllMarketplaceIntBridge',
          'createIntBridge',
          'updateIntBridge',
          'editIntBridge',
          'getIntBridgeDetails',
          'getPostmanData',
          'getInstance',
          'editInstance',
          'updateInstance',
          'startService',
          'stopService',
          'refreshService',
          'getServiceStatus',
          'addToSourceTarget',
          'copyIntBridge',
          'downloadLogs',
          'getDLData',
          'getJDBCStorageNames',
          'getJDBCVersions',
          'getJDBCData',
          'getDLVersions',
          'getDLEnv',
          'createDLEnv',
          'getDLEnvById',
          'updateDLEnv',
          'getDLEnvDetails',
          'createInstance',
          'updateInstanceData',
          'getPlanDetails',
          'getTimezones',
          'clearLogs',
          'downloadEncodedFile',
          'exportIB',
          'importIB'
        ],
        baseUrl: this.baseURL,
        route: 'api/integrationBridge',
      },
      {
        api: ['getAllCountries'],
        baseUrl: this.baseURL,
        route: 'api/countries',
      },

      {
        api: [
          'saveSubscription',
          'getInvoiceList',
          'getPaymentList',
          'getBillingInfo',
          'getCurrentPlan',
          'getDashboardDetails',
          'getProductList',
          'getSessionChekoutStatus',
          'updatePaymentInfo',
        ],
        baseUrl: this.baseURL,
        route: 'api/payment',
      },
      {
        api: [
          'getAllVendors',
          'deleteVendor',
          'blockVendor',
          'getVendorDetails',
          'editVendor',
          'updateVendor',
        ],
        baseUrl: this.baseURL,
        route: 'vendors/users',
      },
      {
        api: [
          'getmlenv',
          'deletemlenv',
          'createmlenv',
          'editmlenv',
          'updatemlenv'
        ],
        baseUrl: this.baseURL,
        route: 'api/mlenvsettings',
      },
      {
        api: [
          'generate',
          'save',
          'update',
          'list-active',
          'view',
          'delete'
        ],
        baseUrl: this.baseURL,
        route: 'api/client',
      },
    ];
  }
}
